import React, { ReactNode } from "react";
import { MsgBox } from ".";
import * as bd from "../index";

let msgBoxList = [];

export type Void = () => void;
export type MsgBoxButtonAction = (hide: Void) => void;

export type MsgBoxButtonProps = {
    variant?: "" | "inherit" | "contained" | "flat" | "icon" | "text" | "outline";
    color?: "" | "inherit" | "default" | "primary" | "secondary";
    className?: string;
    title: ReactNode;
    action?: MsgBoxButtonAction;
};

export const msgbox = (
    title?: ReactNode,
    body?: ReactNode,
    buttons?: string | MsgBoxButtonProps[] | ((hide: Void) => ReactNode),
    props?: { className?: string; backdropClassName?: string }
) => {
    if (msgBoxList.length > 0) msgBoxList[0].show(title, body, buttons, props);
};

type MsgBoxContainerPropsType = {
    backdropClassName?: string;
    className?: string;
};

type MsgBoxContainerStateType = {
    list: any;
};

export class MsgBoxContainer extends React.Component<MsgBoxContainerPropsType, MsgBoxContainerStateType> {
    constructor(props) {
        super(props);
        this.state = { list: [] };
    }

    handleClose = (key: any) => {
        const item = this.state.list.find((item) => item.key === key);
        if (item) {
            setTimeout(() => {
                var new_list = this.state.list.filter((x) => x !== item);
                this.setState({ list: new_list });
            }, 1000);
        }
    };

    show = (title, body, buttons, props) => {
        const id = "m-" + Date.now();
        if (typeof buttons === "string") {
            var btn_title = buttons;
            buttons = (hide) => (
                <bd.Button variant="text" color="primary" onClick={hide}>
                    {btn_title}
                </bd.Button>
            );
        }

        if (Array.isArray(buttons)) {
            var a = buttons;
            buttons = (hide) => (
                <bd.Flex content="end" align="center" gap={1}>
                    {a.map((x, xIndex) => (
                        <bd.Button
                            key={xIndex}
                            variant={x.variant ?? "text"}
                            color={x.color ?? "primary"}
                            className={x.className}
                            onClick={() => (!x.action ? hide() : x.action(hide))}
                        >
                            {x.title}
                        </bd.Button>
                    ))}
                </bd.Flex>
            );
        }

        const m = (
            <MsgBox
                key={id}
                onClose={() => this.handleClose(id)}
                title={title}
                body={body}
                buttons={buttons}
                backdropClassName={props?.backdropClassName}
                className={props?.className}
            />
        );
        this.setState({ list: [...this.state.list, m] });
    };

    componentDidMount() {
        msgBoxList.push(this);
    }

    componentWillUnmount() {
        const index = msgBoxList.indexOf(this);
        if (index > -1) {
            msgBoxList.splice(index, 1);
        }
    }

    render() {
        return this.state.list.map((x) => x);
    }
}
